import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { GTMService } from '../../services/gtm.service';

@Component({
  selector: 'search-results',
  templateUrl: './search-results.component.html'
})
export class SearchResultsComponent implements OnChanges {

  @Input() establishmentsOnline = [];
  @Input() ownPartnershipsOnly = false;
  @Input() establishments = [];
  @Input() cashbackPartners = [];
  @Input() searchType;
  @Input() loggedUser;
  @Input() scrolling;
  @Input() loading;
  @Input() searchParams;
  @Output() scrollSearch = new EventEmitter();

  user;
  searchQuery: string;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private gtm: GTMService
  ) {
    this.user = this.userService.getLoggedUser();
  }

  getUserRole = () => this.userService.getUserLevel();
  getLoggedCompany = () => this.userService.getLoggedAccount();

  visibleOnlineEstablishments() {
    if (!this.establishmentsOnline || !this.establishmentsOnline.length) {
      return [];
    }

    if (this.searchType && this.searchType.seeMore) {
      return this.establishmentsOnline;
    }

    // Uma linha de cards (mesmo limite do listagem legado)
    return this.establishmentsOnline.slice(0, 4);
  }

  async ngOnChanges() {
    this.searchQuery = this.route.snapshot.queryParamMap.get('search') || '';

    const category = 'search';
    const action = 'searchFound';
    const label = this.searchQuery.toLowerCase();

    this.gtm.interaction(category, action, label);
  }

  showEstablishments() {
    return (
      ((this.establishmentsOnline.length || this.cashbackPartners.length) && !this.establishments.length) ||
      this.establishments.length &&
      !this.searchType.seeMore &&
      !this.loading 
    );
  }
}
